import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Card, CardBody, Col, Container, Row, Table } from 'reactstrap';
import { isEmpty, map } from 'lodash';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';

//Import Image
import logo from '../../assets/images/logo-sm.svg';
import { getClientsDetail } from '../../store/actions';

//redux
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect } from 'react';

const ClientDetails = (props: any) => {
  const dispatch = useDispatch();

  const { clientDetail } = useSelector((state: any) => ({
    clientDetail: state.clients.clientDetail,
  }));

  const {
    match: { params },
  } = props;

  useEffect(() => {
    dispatch(getClientsDetail(params.id));
  }, [dispatch, params]);

  //   //Print the Invoice
  // const printInvoice = () => {
  //   window.print();
  // };

  return (
    <React.Fragment>
      <div className="page-content">
        <PageTitle>
          Invoice Detail | Minia - React Admin & Dashboard Template
        </PageTitle>
        <Container fluid>
          {/* Render Breadcrumbs
              <Breadcrumbs title="Invoices" breadcrumbItem="Invoice Detail" />
              {!isEmpty(clientDetail) && (
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <div className="invoice-title">
                          <div className="d-flex align-items-start">
                            <div className="flex-grow-1">
                              <div className="mb-4">
                                <img src={logo} alt="" height="24" />
                                <span className="logo-txt">Minia</span>
                              </div>
                            </div>
                            <div className="flex-shrink-0">
                              <div className="mb-4">
                                <h4 className="float-end font-size-16">
                                  Invoice # 12
                                </h4>
                              </div>
                            </div>
                          </div> */}
          {/* <address>
                            <br />
                             {map(
                              clientDetail.shippingAddress.split(","),
                              (item, key) => (
                                <React.Fragment key={key}>
                                  <span>{item}</span>
                                  <br />
                                </React.Fragment>
                              )
                            )} 
                          </address> */}
          {/* </div>
                        <hr className="my-4" /> */}
          {/* <Row>
                          <Col sm="6">
                            <div>
                              <h5 className="font-size-15 mb-3">Billed To:</h5>
                              { map(
                                clientDetail.billingAddress.split(","),
                                (item, key) => (
                                  <React.Fragment key={key}>
                                    <span>{item}</span>
                                    <br />
                                  </React.Fragment>
                                )
                              )} 
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <div>
                                <h5 className="font-size-15">Order Date:</h5>
                                <p>{clientDetail.orderDate}</p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <h5 className="font-size-15">Payment Method:</h5>
                              <p className="mb-1">{clientDetail.card}</p>
                              <p>{clientDetail.email}</p>
                            </div>
                          </Col>
                        </Row> */}
          {/* <div className="py-2 mt-3">
                          <h3 className="font-size-15 fw-bold">Order summary</h3>
                        </div>
                        <div className="p-4 border rounded">
                          <div className="table-responsive"> */}
          {/* <Table className="table-nowrap align-middle mb-0">
                              <thead>
                                <tr>
                                  <th style={{ width: "70px" }}>No.</th>
                                  <th>Item</th>
                                  <th
                                    className="text-end"
                                    style={{ width: "120px" }}
                                  >
                                    Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {map(
                                  clientDetail.orderSummary.items,
                                  (item, key) => (
                                    <tr key={key}>
                                      <td>{item.id}</td>
                                      <td>
                                        <h5 className="font-size-15 mb-1">
                                          {item.item}
                                        </h5>
                                        <p className="font-size-13 text-muted mb-0">
                                          {item.adminName}{" "}
                                        </p>
                                      </td>
                                      <td className="text-end">{item.price}</td>
                                    </tr>
                                  )
                                )}
                                <tr>
                                  <td colSpan={2} className="text-end">
                                    Sub Total
                                  </td>
                                  <td className="text-end">
                                    {clientDetail.orderSummary.subTotal}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2} className="border-0 text-end">
                                    <strong>Shipping</strong>
                                  </td>
                                  <td className="border-0 text-end">
                                    {clientDetail.orderSummary.shipping}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2} className="border-0 text-end">
                                    <strong>Total</strong>
                                  </td>
                                  <td className="border-0 text-end">
                                    <h4 className="m-0">
                                      {clientDetail.orderSummary.total}
                                    </h4>
                                  </td>
                                </tr>
                              </tbody>
                            </Table> */}
          {/* </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )} */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClientDetails;
